import { IUserEntitiesAction } from "modules/Content/interfaces";
import { USER_ENTITIES } from "../constants/actionTypes";

const EntitiesState = {
  campaignId: 0,
  assetId: 0,
  versionId: 0,
};

export const userEntitiesReducer = (
  state = EntitiesState,
  action: IUserEntitiesAction
) => {
  let newState = { ...state };
  switch (action.type) {
    case USER_ENTITIES.LOAD:
      return newState;

    case USER_ENTITIES.LOAD_SUCCESS:
      newState.campaignId = action.payload.campaign.id;
      newState.assetId = action.payload.asset.id;
      newState.versionId = action.payload.version.id;
      return newState;
    case USER_ENTITIES.LOAD_FAIL:
      return newState;
    case USER_ENTITIES.RESET_ENTITIES:
      newState.campaignId = 0;
      newState.assetId = 0;
      newState.versionId = 0;
      return newState;
    default:
      return state;
  }
};
